import { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination, Tooltip } from 'antd'
import MyIcon from '../../components/general/icon'
import FilterPresentationSlot from './filter'
import PresentationSlotRibbon from './ribbon'
import AddPresentationSlot from './add'
import EditPresentationSlot from './edit'
import DeletePresentationSlot from './delete'
import EmptyPresentationSlot from './empty'

export default function PresentationSlot() {
    const [currentPage, setCurrentPage] = useState(1)
    const [propsData, setPropsData] = useState({})
    const [slotData, setSlotData] = useState({})
    const [isDeleteVisible, setIsDeleteVisible] = useState(false)
    const [isAddVisible, setIsAddVisible] = useState(false)
    const [isEditVisible, setIsEditVisible] = useState(false)
    const [isEmptyVisible, setIsEmptyVisible] = useState(false)

    const initialConditions = {
        keywords: '',
        campus: 0,
        status: 0,
        date: ''
    }
    const [filterValue, setFilterValue] = useState(initialConditions)

    const getSlotData = () => {
        axios.post('/admin/event_slot/list', {
            keywords: filterValue.keywords,
            campus: filterValue.campus,
            status: filterValue.status,
            date: filterValue.date,
            slot_type: 1,
            page: currentPage,
            per_page: 20
        })
            .then(function (response) {
                if (response.errcode === 0) {
                    setSlotData({
                        'total_page': response.data.total_page,
                        'current_page': response.data.current_page,
                        'total': response.data.total,
                        'list': response.data.list
                    })
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }

    useEffect(() => {
        getSlotData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, filterValue])

    const deleteSlot = (id, name) => {
        setIsDeleteVisible(true)
        setPropsData({ id, name })
    }

    const editSlot = (item) => {
        setIsEditVisible(true)
        setPropsData({ ...item })
    }

    const CAMPUS_MAP = {
        1: '兰州职业技术学院',
        2: '雁儿湾校区',
        3: '桃林校区'
    }

    const STATUS = {
        1: { label: '未预约', color: 'green' },
        2: { label: '已占用', color: 'red' }
    }

    return (
        <div className="public-page">
            <div className="public-container">
                <div className="public-header">
                    <div className="public-title">宣讲会资源管理</div>
                    <PresentationSlotRibbon filterValue={filterValue} setFilterValue={setFilterValue} isAddVisible={() => { setIsAddVisible(true) }} isEmptyVisible={() => { setIsEmptyVisible(true) }}/>
                </div>

                <FilterPresentationSlot filterValue={filterValue} setFilterValue={setFilterValue} setCurrentPage={setCurrentPage} />

                <div className='public-main-style2'>
                    <table className='public-main-style2-item'>
                        <thead>
                            <tr className='public-main-style2-thead'>
                                <th style={{ textAlign: 'left', paddingLeft: '20px' }}>日期</th>
                                <th>时段</th>
                                <th>状态</th>
                                <th>场地</th>
                                <th>所属校区</th>
                                <th style={{ width: '50px' }}></th>
                            </tr>
                        </thead>

                        <tbody>
                            {slotData.list && (slotData.list.length > 0 ? (slotData.list.map((item) => (
                                <tr className='public-main-style2-tbody' key={item.id} onClick={() => { editSlot(item) }}>
                                    <td style={{ textAlign: 'left', paddingLeft: '20px' }}>{item.date}</td>
                                    <td>{item.time_range}</td>
                                    <td style={{ color: STATUS[item.status]?.color }}>
                                        {STATUS[item.status]?.label || '-'}
                                    </td>
                                    <td>{item.venue_name}</td>
                                    <td>{CAMPUS_MAP[item.campus]}</td>
                                    <td style={{ width: '100px' }}>
                                        <div className='public-main-style2-operation-box'>
                                            <Tooltip placement="bottom" color='#1A1B1C' title="删除">
                                                <div className='public-main-style2-operation' onClick={(event) => { event.stopPropagation(); deleteSlot(item.id, item.name) }}>
                                                    <MyIcon name='huishouzhan' />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </td>
                                </tr>
                            ))) : (
                                <tr className='public-main-style2-tbodyEmpty'>
                                    <td colSpan="6"><span>暂无数据</span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className='pagination'>
                    <Pagination
                        current={currentPage}
                        total={slotData.total}
                        pageSize={20}
                        onChange={(page) => setCurrentPage(page)}
                        showTotal={(total) => `共${total}条`}
                        showSizeChanger={false}
                        hideOnSinglePage={true}
                        showQuickJumper={true}
                    />
                </div>
            </div>

            {isDeleteVisible && <DeletePresentationSlot
                data={propsData}
                getSlotData={getSlotData}
                isOpen={isDeleteVisible}
                isCancel={() => { setIsDeleteVisible(false) }}
            />}
            {isAddVisible && <AddPresentationSlot
                getSlotData={getSlotData}
                isOpen={isAddVisible}
                isCancel={() => { setIsAddVisible(false) }}
            />}
            {isEditVisible && <EditPresentationSlot
                data={propsData}
                getSlotData={getSlotData}
                isOpen={isEditVisible}
                isCancel={() => { setIsEditVisible(false) }}
            />}
            {isEmptyVisible && <EmptyPresentationSlot
                filterValue={filterValue}
                getSlotData={getSlotData}
                isOpen={isEmptyVisible}
                isCancel={() => { setIsEmptyVisible(false) }}
            />}
        </div>
    )
}
